import React, { useMemo } from 'react';
import { Box, Flex, Grid, Image, Text } from '@chakra-ui/react';
import { Socials } from '../Socials/socials';
import { containerMaxWXl } from '../ContentContainer/contentContainer';
import { useTranslation } from 'react-i18next';
import { Link as ReactLink } from 'react-router-dom';
import { CompanyInformation } from './companyInformation';
import { Newsletter } from './NewsLetter/newsletter';
import { isLauncher } from '../../utils/launcher';
import Vendor from '../../vendor.config';
import { Color } from 'src/theme/color';
import { getTransparent } from '../../utils/themer';

export const Footer = () => {
	const { t } = useTranslation();

	const hashupBranding = useMemo(() => {
		if (!Vendor.data.branding.cartridge.toLowerCase().includes('hashup')) {
			return <></>;
		}

		return (
			<Text
				ml="15px"
				fontWeight="800"
				lineHeight="38px"
				fontSize="31px"
			>
				HashUp
			</Text>
		);
	}, []);

	return (
		<Box
			w="100%"
			pt={{ base: '35px', md: '60px' }}
			maxW={containerMaxWXl}
		>
			{/* desktop */}
			<Flex
				display={{ base: 'none', md: 'flex' }}
				flexWrap="wrap"
				justifyContent="space-between"
				marginBottom={{ base: '0', hashup: '28px', xl: '0' }}
			>
				<Flex alignItems="center">
					<Image
						maxH="31px"
						src={Vendor.gui.asset.logoSmall}
					/>
					{hashupBranding}
				</Flex>
				<Flex
					fontSize="12px"
					justifyContent="center"
					w={{ base: '100%', md: 'auto' }}
				>
					<Socials hasDescription />
				</Flex>
			</Flex>
			<Box display={{ base: 'block', hashup: `${isLauncher() ? 'none' : 'block'}`, xl: 'block' }}>
				<Flex
					m={{ md: '30px 0', hashup: '50px 0' }}
					fontSize="14px"
					display={{ base: 'none', md: 'inline-flex' }}
					alignItems="center"
					as={ReactLink}
					to="/"
				>
					<Text color={Color.ACTION}>Hash</Text>
					<Text>Up.it</Text>
					<Box
						h="1px"
						w="18px"
						bg={Color.ACTION}
						m="0 14px"
					/>
					<Text>{t('footer.goToMain').toString()}</Text>
				</Flex>
				<Grid
					display={{ base: 'none', md: 'grid' }}
					templateColumns={{ md: 'repeat(3, 1fr)' }}
				>
					<CompanyInformation t={t} />
					<Box />
					{/* todo */}
					{/* <FooterMenu */}
					{/*	header="HASHUP" */}
					{/*	menuElements={[ */}
					{/*		{ name: 'Team', link: '' }, */}
					{/*		{ name: 'Media o nas', link: '' }, */}
					{/*		{ name: 'Praca w #', link: '' }, */}
					{/*	]} */}
					{/* /> */}
					{/* <Grid */}
					{/*	templateRows='repeat(2, 1fr)' */}
					{/*	templateColumns='repeat(1, 1fr)' */}
					{/*	gap={4} */}
					{/* > */}

					{/* </Grid> */}
					<Newsletter
						headerStyle={{ color: getTransparent(Color.TEXT, 50), fontWeight: '600', fontSize: '12px' }}
						loading={false}
					/>
				</Grid>
			</Box>

			{/* mobile */}
			<Flex
				display={{ base: 'flex', md: 'none' }}
				flexWrap="wrap"
			>
				<Flex
					as={ReactLink}
					to="/"
					alignItems="center"
					w="100%"
					justifyContent="center"
					mb="15px"
				>
					<Image
						maxH="15px"
						src="/icons/hash_logo.svg"
					/>
					<Text
						ml="6px"
						fontWeight="800"
						lineHeight="38px"
						fontSize="14px"
					>
						ODL
					</Text>
				</Flex>
				<Flex
					mb="25px"
					fontSize="12px"
					justifyContent="center"
					w="100%"
				>
					<Socials />
				</Flex>
				<CompanyInformation
					t={t}
					isMobile
				/>
			</Flex>
		</Box>
	);
};
